import { Observable } from 'rxjs';

export class TopbarFeature {
    /**
     * Unique key for the feature.
     * This key is used to identify the feature in the topbar and should be unique across all features.
     */
    key: string;

    /**
     * The icon to display for this feature in the topbar.
     * This should correspond to an icon in the application's icon set.
     */
    icon: string;

    /**
     * The title of the feature, which will be displayed in the topbar.
     */
    title: string;

    /**
     * The action to perform when this feature is activated.
     * This should correspond to a method in the topbar service.
     */
    action: string;

    /**
     * Indicates if this feature is pinned in the topbar.
     * Pinned features are always shown unless overridden by user settings.
     */
    pinned: boolean;

    /**
     * Optional configuration key that must be set for the feature to be available.
     * If this key is not set, the feature will not be shown.
     */
    requiredConfig?: string;

    /**
     * Optional configuration key that must NOT be set for the feature to be available.
     * If this key is set, the feature will not be shown.
     */
    reverseRequiredConfig?: string;

    /**
     * Optional permissions required for this feature to be available.
     * If the user does not have these permissions, the feature will not be shown.
     */
    requiredPermissions?: string | string[];

    badge?: {
        enabled: boolean;
        source?: Observable<number>;
    };

    constructor(data: Partial<TopbarFeature>) {
        this.key = data.key;
        this.icon = data.icon || '';
        this.title = data.title || '';
        this.action = data.action || '';
        this.pinned = data.pinned || false;
        this.requiredConfig = data.requiredConfig;
        this.reverseRequiredConfig = data.reverseRequiredConfig;
        this.requiredPermissions = data.requiredPermissions;
        this.badge = data.badge || undefined;
    }
}
